import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../auth/auth.api";
import TDepartment from "@/types/common/department/TDepartment";
import TPosition from "@/types/common/position/TPosition";
import { TSuccessResponse } from "@/types/general/TSuccessResponse";

export const commonApi = createApi({
  reducerPath: "commonApi",
  tagTypes: ["Common"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDepartments: builder.query<TSuccessResponse<TDepartment[]>, void>({
      query: () => "/common/department",
    }),

    getPositions: builder.query<
      TSuccessResponse<TPosition[]>,
      { dept_id?: number }
    >({
      query: ({ dept_id }) => {
        return {
          url: "/common/position",
          params: { ...(dept_id ? { dept_id } : {}) },
        };
      },
    }),

    getMe: builder.query<
      TSuccessResponse<TPosition[]>,
      { user_id?: number | string }
    >({
      query: ({ user_id }) => {
        return {
          url: "/common/me",
          params: { user_id },
        };
      },
    }),
  }),
});

export const {
  useGetDepartmentsQuery,
  useGetPositionsQuery,
  useGetMeQuery,
  useLazyGetPositionsQuery,
} = commonApi;
